import { render } from "./TinyLabel.vue?vue&type=template&id=19d51592&scoped=true"
const script = {}

import "./TinyLabel.vue?vue&type=style&index=0&id=19d51592&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d51592"]])

export default __exports__